import React, { FC, memo } from 'react';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { FilterData } from '@blocs.filter';
import { useScheduleStatusOptions } from '../../../shared/hooks';

type Props = FilterData & {
  withNotYetSent?: boolean;
  dropdownPositionFixed?: boolean;
  handleSubmitForm?: () => void;
};

const ScheduleStatus: FC<Props> = ({
  withNotYetSent = false,
  name,
  label,
  dropdownPositionFixed,
  handleSubmitForm,
}) => {
  const scheduleStatusOptions = useScheduleStatusOptions(withNotYetSent);

  return (
    <DropdownWithChildren
      withFormik
      withSelectAll
      isMultipleSelect
      dropdownPositionFixed={dropdownPositionFixed}
      name={name}
      toggleLabel={label}
      options={scheduleStatusOptions}
      onOptionsChange={handleSubmitForm}
    />
  );
};

export default memo(ScheduleStatus);
